import React from 'react'
import { css } from '@emotion/react'
import { colors, font } from 'plume-ui'
import { IcomoonIcon } from '../../../atoms/IcomoonIcon'

type Props = {
  className?: string
}

export const HelpIndicator: React.FC<Props> = (props) => {
  return (
    <div
      className={
        props.className
          ? ['help-indicator', props.className].join(' ')
          : 'help-indicatior'
      }
      css={css`
        text-align: right;
        display: block;
      `}
    >
      {/* NOTE: iconはクリック可能。spanには下線をつけるが、iconには下線をつけないので、Afterを利用して下線をつけている */}
      <span
        css={css`
          *,
          *::after {
            transition: all 0.2s ease 0s;
          }
          > a,
          i {
            color: ${colors.textLight};
          }
          :hover {
            > * {
              color: ${colors.blue50};
            }
          }
        `}
      >
        <a
          href="https://help.initial.inc/ja/articles/7434600"
          target="_blank"
          rel="noopener noreferrer"
          css={css`
            font-weight: ${font.weight.normal};
            line-height: 100%;
            font-size: 11px;
            letter-spacing: 0.02em;
            text-decoration: none;
            > span {
              position: relative;
            }
            > span::after {
              position: absolute;
              content: '';
              width: 100%;
              height: 1px;
              bottom: 1px;
              left: 0;
              background-color: ${colors.link};
              opacity: 0;
            }
            :hover {
              > i {
                color: ${colors.link};
              }
              > span::after {
                opacity: 1;
              }
            }
          `}
        >
          <IcomoonIcon
            name="question-circle-fill"
            css={css`
              line-height: 100%;
              font-size: 14px;
              margin-right: 2px;
              vertical-align: text-bottom;
            `}
          />
          <span>キーワード検索について</span>
        </a>
      </span>
    </div>
  )
}
